export default __webpack_public_path__ + "static/media/empty_view.a4108296.png";